// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Filter = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" d="M10 9.5v5H8v-5" />
    <path fill="currentColor" d="M9.5 11.25V9.447L13.132 4H4.868L8.5 9.447v1.803L3 3h12z" />
  </svg>
);
const ForwardRef = forwardRef(Filter);
export default ForwardRef;
